import { useEffect, useRef, useState } from 'react';
import { toast } from 'sonner';
import { Map as MapIcon, Trash2, Upload, Loader2 } from 'lucide-react';
import { EXT_KEYS } from '../lib/policy';
import { listMaps, deleteMap, importMbtiles } from '../lib/ownTiles';

// KRITIS admin: allowed external services, company map server, saved offline areas
export function KritisMaps({ t, draft, setDraft }) {
  const allow = draft.allow || [], m = draft.map || { url: '', type: 'xyz', layers: '', name: '' };
  const setM = (k, v) => setDraft({ ...draft, map: { ...m, [k]: v } });
  return (
    <div className="kr-maps" data-testid="kritis-maps">
      <b className="small-hint">{t.omAllowTitle}</b>
      <small className="muted">{t.omAllowHint}</small>
      <div className="pv-list">
        {EXT_KEYS.map((k) => <label key={k}><input type="checkbox" data-testid={`kritis-allow-${k}`} checked={allow.includes(k)} onChange={() => setDraft({ ...draft, allow: allow.includes(k) ? allow.filter((x) => x !== k) : [...allow, k] })} /> {t['omExt_' + k]}</label>)}
      </div>
      <label className="kr-switch"><input type="checkbox" data-testid="kritis-cache-toggle" checked={draft.cache !== false} onChange={(e) => setDraft({ ...draft, cache: e.target.checked })} /> {t.omCacheAllow}</label>
      <b className="small-hint">{t.omServer}</b>
      <small className="muted">{t.omServerHint}</small>
      <div className="row">
        <input className="input" data-testid="kritis-map-name" placeholder={t.omServerName} value={m.name} onChange={(e) => setM('name', e.target.value)} />
        <select data-testid="kritis-map-type" value={m.type} onChange={(e) => setM('type', e.target.value)}><option value="xyz">{t.omXyz}</option><option value="wms">WMS</option></select>
      </div>
      <input className="input" data-testid="kritis-map-url" placeholder={m.type === 'wms' ? 'https://gis.intern/wms' : 'https://gis.intern/tiles/{z}/{x}/{y}.png'} value={m.url} onChange={(e) => setM('url', e.target.value.trim())} />
      {m.type === 'wms' && <input className="input" data-testid="kritis-map-layers" placeholder={t.mdWmsLayers} value={m.layers} onChange={(e) => setM('layers', e.target.value.trim())} />}
    </div>
  );
}

// imported MBTiles maps on this device (USB / network drive -> offline)
export function OwnMaps({ t }) {
  const [maps, setMaps] = useState([]);
  const [pct, setPct] = useState(null);
  const inp = useRef(null);
  useEffect(() => { const on = () => listMaps().then(setMaps, () => {}); on(); window.addEventListener('giss-ownmaps', on); return () => window.removeEventListener('giss-ownmaps', on); }, []);
  const load = async (f) => {
    if (f.size > 600 * 1024 * 1024 && !window.confirm(t.omBig)) return;
    setPct(0);
    try { const m = await importMbtiles(f, setPct); toast.success(t.omDone.replace('{n}', m.tiles).replace('{name}', m.name)); } catch (e) { toast.error(t['omErr_' + e.message] || t.omErr); }
    setPct(null);
  };
  return (
    <div className="md-block om-box" data-testid="own-maps">
      <b><MapIcon size={14} /> {t.omTitle}</b>
      <small className="muted">{t.omHint}</small>
      {maps.map((m) => (
        <div key={m.id} className="row" data-testid={`own-map-${m.id}`}>
          <span className="wms-name">🗺️ {m.name}</span>
          <small className="muted">{m.tiles} · Z{m.minZ}–{m.maxZ} · {(m.size / 1048576).toFixed(0)} MB</small>
          <button className="icon-btn danger" data-testid={`own-map-del-${m.id}`} onClick={() => window.confirm(t.omDelAsk) && deleteMap(m.id)}><Trash2 size={14} /></button>
        </div>
      ))}
      <button className="btn btn-outline btn-sm" disabled={pct != null} data-testid="own-map-import-btn" onClick={() => inp.current?.click()}>{pct != null ? <><Loader2 size={14} className="spin" /> {Math.round(pct * 100)} %</> : <><Upload size={14} /> {t.omImport}</>}</button>
      <input ref={inp} type="file" hidden accept=".mbtiles" data-testid="own-map-input" onChange={(e) => { const f = e.target.files?.[0]; e.target.value = ''; if (f) load(f); }} />
    </div>
  );
}
